import { render, staticRenderFns } from "./ModalSearchTalent.vue?vue&type=template&id=334872eb&scoped=true&"
import script from "./ModalSearchTalent.vue?vue&type=script&lang=js&"
export * from "./ModalSearchTalent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334872eb",
  null
  
)

export default component.exports